/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const QuestionCircle = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 16 16" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z" /><path d="M11 6.9c0 1.3-.9 2.4-2.1 2.8v.8H7.2V8.2h.9c.7 0 1.3-.6 1.3-1.2s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3H5c0-1.6 1.4-2.9 3-2.9s3 1.2 3 2.8zm-3.9 4.7h1.7V13H7.1v-1.4z" />
      </g>
    </svg>
  </span>
);

QuestionCircle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

QuestionCircle.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default QuestionCircle;
